export const defaultEmptyFunction = () => {};
